/* eslint-disable eqeqeq */
import React, { useEffect, useState } from 'react';
import useLocales from 'src/hooks/useLocales';
import Loader from 'src/components/loader/Loader';

import { IRentPayment } from 'src/@types/Choqorak/MainTables/RentPayment.ts/RentPayment';
import { GetMonthName } from 'src/sections/common/GetMonthName';
import { ShopReportData, ShopReportEntry } from 'src/@types/Choqorak/MainTables/Shop/Shop';

type Props = {
  Report?: ShopReportData;
};

interface GroupedReport {
  shopTypeName: string;
  statuses: ShopReportEntry[];
}

export default function ShopReportPDF({ Report }: Props) {
  const recordsPerPage = 37;
  const { translate } = useLocales();
  const [dirction, setDirection] = useState('ltr');

  const lang = localStorage.getItem('i18nextLng');

  useEffect(() => {
    if (lang === 'ps' || lang === 'dr') {
      setDirection('rtl');
    } else {
      setDirection('ltr');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dirction]);

  if (!Report || !Report.list || Report.list.length === 0) {
    return <Loader />;
  }

  const thStyle = `table-th-Attandence-Report text-[12px]`;

  const tdStyle = `table-td-Attandence-Report text-[11px]`;

  const width = 'w-[240mm]';

  const totalPages = Math.ceil(Report!.list.length / recordsPerPage);

  const groupedData: GroupedReport[] = Report.report.reduce<GroupedReport[]>((acc, item) => {
    const existingGroup = acc.find((group) => group.shopTypeName === item.shopTypeName);
    if (existingGroup) {
      existingGroup.statuses.push(item);
    } else {
      acc.push({ shopTypeName: item.shopTypeName, statuses: [item] });
    }
    return acc;
  }, []);

  return (
    <div className="px-7">
      {Report.list.length > 0 ? (
        <>
          {/* Loop through pages */}
          {Array.from({ length: totalPages }).map((_, pageIndex) => (
            <div
              key={pageIndex}
              className={`${width} h-[297mm] mx-auto bg-white text-black`}
              dir={`${dirction}`}
            >
              <div className="page-break py-5 px-2">
                <div className="border-[2px] border-black border-b-0 pt-4 pb-2">
                  <div className="flex justify-between items-center px-5">
                    {/* Left Logo */}
                    <div className="flex flex-col justify-center items-center text-center">
                      <img
                        src={require('src/assets/Choqorak/logo1.png')}
                        width="100"
                        height="100"
                        alt="logo1"
                      />
                    </div>

                    {/* Center Text */}
                    <div className="text-base text-center font-bold print:text-base">
                      <h3>چقرک مرکز پخش مواد خوراکی</h3>
                    </div>

                    {/* Right Logo */}
                    <div className="flex flex-col justify-center items-center text-center">
                      <img
                        src={require('src/assets/Choqorak/logo2.png')}
                        width="200"
                        height="400"
                        alt="logo2"
                      />
                    </div>
                  </div>
                </div>

                <div>
                  <table className="table-style print:text-black">
                    <thead className=" bg-gray-600">
                      <tr className="w-full bg-gray-600 print:bg-gray-600">
                        <th scope="col" className={`${thStyle}`}>
                          {translate('ShopReport.No')}
                        </th>
                        <th scope="col" className={`${thStyle}`}>
                          {translate('ShopReport.Block')}
                        </th>
                        <th scope="col" className={`${thStyle}`}>
                          {translate('ShopReport.Floor')}
                        </th>
                        <th scope="col" className={`${thStyle}`}>
                          {translate('ShopReport.ShopCode')}
                        </th>
                        <th scope="col" className={`${thStyle}`}>
                          {translate('ShopReport.RentPerMonth')}
                        </th>
                        <th scope="col" className={`${thStyle}`}>
                          {translate('ShopReport.ShopType')}
                        </th>
                        <th scope="col" className={`${thStyle}`}>
                          {translate('ShopReport.Status')}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {Report.list
                        .slice(pageIndex * recordsPerPage, (pageIndex + 1) * recordsPerPage)
                        .map((record: any, index: number) => (
                          <tr key={index} style={{ pageBreakInside: 'avoid' }}>
                            <td className={`${tdStyle}`}>{pageIndex * recordsPerPage + index + 1}</td>
                            <td className={`${tdStyle}`}>{record.blockName}</td>
                            <td className={`${tdStyle}`}>{record.floorCode}</td>
                            <td className={`${tdStyle}`}>{record.shopCode}</td>
                            <td className={`${tdStyle}`}>{record.rentPerMonth}</td>
                            <td className={`${tdStyle}`}>{record.shopType}</td>
                            <td className={`${tdStyle}`}>{record.shopStatus}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>

                {/* Footer for each page */}
                {/* <div
                  className={`absolute bottom-5 w-[230mm] mx-auto border-t-2 border-black text-[8pt]`}
                >
                  <div className="px-5 relative w-full mx-auto" dir="ltr">
                    <div className="flex justify-center items-center w-full">
                      <img
                        src={require('src/assets/Choqorak/footer.png')}
                        width="500"
                        height="50"
                        alt="footer"
                      />
                    </div>
                  </div>
                </div> */}
              </div>

              {/* Show Summary ONLY on the Last Page */}
              {pageIndex === totalPages - 1 && (
                <div
                  className={`${width} h-[297mm] mx-auto bg-white text-black`}
                  dir={`${dirction}`}
                >
                  <div className="page-break py-5 px-2">
                    <div className="border-[2px] border-black border-b-0 pt-4 pb-2">
                      <div className="flex justify-between items-center px-5">
                        {/* Left Logo */}
                        <div className="flex flex-col justify-center items-center text-center">
                          <img
                            src={require('src/assets/Choqorak/logo1.png')}
                            width="100"
                            height="100"
                            alt="logo1"
                          />
                        </div>

                        {/* Center Text */}
                        <div className="text-base text-center font-bold print:text-base">
                          <h3>چقرک مرکز پخش مواد خوراکی</h3>
                        </div>

                        {/* Right Logo */}
                        <div className="flex flex-col justify-center items-center text-center">
                          <img
                            src={require('src/assets/Choqorak/logo2.png')}
                            width="200"
                            height="400"
                            alt="logo2"
                          />
                        </div>
                      </div>
                    </div>
                    {/* Summary Section */}
                    <div>
                      <h3 className="text-center text-xl font-bold border-4 border-black p-2">
                        {translate('Shop.Report.ReportSummary')}
                      </h3>
                      <table className="table-auto w-full border-collapse border border-black">
                        <thead>
                          <tr className="bg-gray-200">
                            <th className="px-4 py-2 font-bold border border-black text-center">
                              {translate('GeneralFields.No')}
                            </th>
                            <th className="px-4 py-2 font-bold border border-black text-center">
                              {translate('Shop.ShopType')}
                            </th>
                            <th className="px-4 py-2 font-bold border border-black text-center">
                              {translate('Shop.ShopStatus')}
                            </th>
                            <th className="px-4 py-2 font-bold border border-black text-center">
                              {translate('Shop.Report.HasContract')}
                            </th>
                            <th className="px-4 py-2 font-bold border border-black text-center">
                              {translate('Shop.Report.HasElectricMeter')}
                            </th>
                            <th className="px-4 py-2 font-bold border border-black text-center">
                              {translate('Shop.Report.WithoutElectricMeter')}
                            </th>
                            <th className="px-4 py-2 font-bold border border-black text-center">
                              {translate('Shop.Report.TotalByStatus')}
                            </th>
                            <th className="px-4 py-2 font-bold border border-black text-center">
                              {translate('Shop.Report.TotalByType')}
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {groupedData.map((group, groupIndex) =>
                            group.statuses.map((status, statusIndex) => (
                              <tr key={`${group.shopTypeName}-${status.shopStatusId}`}>
                                <td className="px-4 py-2 border border-black text-center">
                                  {groupIndex + 1}.{statusIndex + 1}
                                </td>

                                {statusIndex === 0 && (
                                  <td
                                    className="px-4 py-2 border border-black text-center"
                                    rowSpan={group.statuses.length}
                                  >
                                    {group.shopTypeName}
                                  </td>
                                )}

                                <td className="px-4 py-2 border border-black text-center">
                                  {status.shopStatusName}
                                </td>
                                <td className="px-4 py-2 border border-black text-center">
                                  {status.shopsWithLastContract}
                                </td>
                                <td className="px-4 py-2 border border-black text-center">
                                  {status.shopsWithElectricMeter}
                                </td>
                                <td className="px-4 py-2 border border-black text-center">
                                  {status.shopsWithoutElectricMeter}
                                </td>
                                <td className="px-4 py-2 border border-black text-center">
                                  {status.totalShopsByStatus}
                                </td>
                                {statusIndex === 0 && (
                                  <td rowSpan={group.statuses.length} className="px-4 py-2 border border-black text-center">
                                    {status.totalShopsByType}
                                  </td>
                                )}
                              </tr>
                            ))
                          )}

                          <tr className="bg-gray-100 font-bold">
                            <td className="px-4 py-2 border border-black text-center" colSpan={4}>
                              {translate('Shop.Report.GrandTotal')}
                            </td>
                            <td colSpan={4} className="px-4 py-2 border border-black text-center">
                              {Report.report.reduce((total, item) => item.totalShopsOverall, 0)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* Footer Section */}
                    {/* <div
                      className={`print:fixed print:bottom-5 print:w-[230mm] print:mx-auto print:border-t-2 print:border-black text-[8pt] hidden print:block`}
                    >
                      <div className="px-5 relative w-full mx-auto" dir="ltr">
                        <div className="flex justify-center items-center w-full">
                          <img
                            src={require('src/assets/Choqorak/footer.png')}
                            width="500"
                            height="50"
                            alt="footer"
                          />
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              )}
            </div>
          ))}
        </>
      ) : (
        <div className="flex justify-center items-center">
          {translate('ReceptionDashboard.NoRecordFound')}
        </div>
      )}
    </div>
  );
}
